import { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import FormRenderer from '../components/FormRenderer';
import { Notice, PageLoader } from '../components/UI';
import { VILLAGE_MODULE } from '../config/modules';
import { useAuth } from '../context/AuthContext';
import { saveRecord, subscribeToDocument } from '../services/data';

export default function VillagePage() {
  const { can } = useAuth();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!can('village', 'view')) return undefined;
    return subscribeToDocument('village', 'profile', (value) => { setRecord(value); setLoading(false); }, (snapshotError) => { setError(snapshotError.message); setLoading(false); });
  }, [can]);

  if (!can('village', 'view')) return <Navigate to="/unauthorized" replace />;

  const save = async (nextRecord) => {
    setBusy(true);
    setError('');
    try {
      if (!can('village', 'edit')) throw new Error('Village edit permission aapel nathi.');
      const id = await saveRecord('village', { ...nextRecord, id: 'profile' }, Boolean(record));
      setSuccess('Village profile successfully updated. Mobile app ma realtime sync thase.');
      return { id };
    } catch (saveError) {
      setError(saveError.message || 'Save failed.');
      throw saveError;
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page-stack">
      <header className="page-heading"><div><p className="eyebrow">Single profile</p><h1>About Village</h1><p>Mobile app na home ane About Village content nu central source.</p></div><span className="heading-icon"><Save size={23} /></span></header>
      {error ? <Notice type="error" onClose={() => setError('')}>{error}</Notice> : null}
      {success ? <Notice type="success" onClose={() => setSuccess('')}>{success}</Notice> : null}
      {loading ? <PageLoader /> : (
        <section className="panel-card standalone-form">
          <FormRenderer
            key="village"
            module={VILLAGE_MODULE}
            initialValue={record}
            fixedDocumentId="profile"
            busy={busy}
            canUpload={can('village', 'media')}
            onSubmit={save}
            onCancel={() => setRecord({ ...record })}
          />
        </section>
      )}
    </div>
  );
}
